$(window).bind("load", function() {

	$('.loading-overlay').addClass('loading-overlay--is-hidden');

});